"use client"

import Link from "next/link"
import { usePathname, useSearchParams } from "next/navigation"
import { useEffect, useState } from "react"

const MainNavbar_3 = ({lang, parent}) => {
    const [showSidebarButton, setShowSidebarButton] = useState(false)
    const [sidebarOpen, setSidebarOpen] = useState(true)
    const [navbarOpen, setNavbarOpen] = useState()
    const [currentNavId, setCurrentNavId] = useState(0)
    const [navbarFixed, setNavbarFixed] = useState(true)
     const pathname = usePathname()
     const searchParams = useSearchParams()
     const search = searchParams.get('url')

     const [url, setUrl] = useState({
          // pathname: window.location.pathname.split(`/${lang}/`)[1] || '', 
          // search: window.location.search
        })


        const sidebarControl = () => {
          if (sidebarOpen){
              setSidebarOpen(!sidebarOpen)
               console.log("sidebarOpen:", sidebarOpen)
               document.getElementById('sidebar').classList.remove('sm:translate-x-0') // works on desktop
               document.getElementById('leftCards')?.classList.remove('sm:ml-72')
      
              // !sidebarOpen ? document.getElementById('table')?.classList.remove('sm:ml-64') : document.getElementById('table')?.classList.add('sm:ml-64')
      
               // document.getElementById('sidebar').classList.remove('-translate-x-full') // works on mobile
              //  callback({sidebarOpen: sidebarOpen})
          }
          else {
              setSidebarOpen(!sidebarOpen)
               console.log("sidebarOpen:", sidebarOpen)
               document.getElementById('sidebar').classList.add('sm:translate-x-0') // works on desktop
               document.getElementById('leftCards')?.classList.add('sm:ml-72')
                // document.getElementById('sidebar').classList.add('-translate-x-full') // works on mobile
              //  callback({sidebarOpen: sidebarOpen})
          }
        
        }


     useEffect(() => {

        // Find the checkbox input by its id
        const checkbox = document.getElementById('check');
        // If the navbar is not open, uncheck the checkbox
        if (!navbarOpen && checkbox) {
          checkbox.checked = false;
        }


     // if document has sidebar, set sidebar button to true, else is false
     setShowSidebarButton(document.getElementById('sidebar'))
          setUrl({
          pathname: parent === 'LANG' ? window.location.pathname.split(`/${lang}/`)[1] || '' : window.location.pathname.split('/')[1] || '',
          search: window.location.search
          });
      // if url includes /workspace/, make the navbar not fixed (returns false below)
      setNavbarFixed(!pathname.includes('/workspace')) // if url

     }, [search, pathname, navbarOpen])

return <header>
  <nav className={`${navbarFixed ? 'fixed' : 'hidden'} w-full z-40 top-4 left-0 `}>
    {/* replaced sticky with hidden above */}
    {/* bg-opacity-50 backdrop-blur-sm */}
    <div className="rounded-2xl shadow-xl border-4 dark:border-slate-800 bg-gray-200 dark:bg-slate-950 w-11/12 md:w-10/12 mx-auto justify-between items-center px-3">

  {showSidebarButton && 

<button
className="fixed top-4 left-4 z-30 inline-flex items-center text-white cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-transparent hidden sm:block outline-none focus:outline-none"
type="button"
onClick={() => sidebarControl()}
>
  {/* <i className="fa-solid fa-bars text-gray-500"></i> */}
  {sidebarOpen === false ? 
  <i className="duration-300 fa-solid fa-bars text-black dark:text-white hover:text-gray-400 text-base"></i> 
  : sidebarOpen === true ? 
  <i className="duration-300 fa-solid fa-x text-black dark:text-white hover:text-gray-400 text-base"></i> : '' }

</button>
}


    <ul className={`navigation  max-w-[90vw] flex flex-wrap justify-between items-center relative ${navbarFixed ? 'mx-auto' : 'mx-4'} py-4`}>


      {/* removed py-4 from above */}
      {/* <a class="logo" href="#">
        <h3 class="font-bold text-2xl">LOGO</h3>
        </a> */}


      <div className="sm:flex sm:justify-center sm:items-center ml-0 sm:mx-8">
        <Link onClick={()=>{setCurrentNavId(0)}} className="logo" href ={lang === 'fr' ? '/fr/' : '/en/'}>
            <img src="/RECTANGLE_TRANSPARENT_LOGO.png" className="h-8" alt="Talnet Logo" />
          </Link>
      </div>

      <input type="checkbox" id="check" />

      <span className="text-black dark:text-white bg-gray-200 dark:bg-slate-700 xl:bg-gray-200 xl:dark:bg-slate-950 menu flex font-montserrat font-bold dark:text-white [&>li]:pl-6 [&>li>a]:text-center [&>li>a]:relative [&>li>a]:transition [&>li>a]:duration-300 [&>li>a]:ease-in-out [&>li>a]:font-normal [&>li>a]:text-base">


  

        {/* <li className={`hover:text-gray-400 ${currentNavId===2 && 'text-gray-400'}`}>
        <Link onClick={()=>{setNavbarOpen(false);  setCurrentNavId(2)}} href = {`/${lang}/talent`}>
        {lang === 'fr' ? 'Talents' : 'Talent Board'}
        </Link>
          </li> */}

  
        {/* <li className={`hover:text-gray-400 ${currentNavId===6 && 'text-gray-400'}`}>
        <Link onClick={()=>{setNavbarOpen(false); setCurrentNavId(6)}} href = {`/${lang === 'fr' ? 'fr/blog' : 'blog'}`}>
        Blog
        </Link>
        </li> */}


        {/* <li className="hover:text-gray-400">
          <Link href={`${lang}/employers/workspace`} className="px-4 py-2 bg-indigo-500 rounded-lg text-white duration-500 hover:bg-indigo-600">
            <span className="font-base text-sm"> {lang === 'fr' ? 'Afficher un Emploi' : 'Post a Job'}</span>
          </Link>
        </li> */}

<li className="hover:text-gray-400">
  <Link
  onClick={()=>setNavbarOpen(false)}
    href={`/${lang}/auth/signin`}
    // className="relative px-4 py-2 bg-indigo-500 rounded-lg text-white duration-500 hover:bg-indigo-600"
        className="relative px-4 py-2 rounded-md text-black bg-gray-100 hover:bg-white dark:bg-slate-200 hover:underline decoration-2 border-2 border-black dark:border-white duration-500"
  >
    <span className="font-base text-sm">
      {lang === 'fr' ? 'Connexion' : 'Sign In'}
    </span>
    {/* Add a sparkle effect on the border */}
    {/* <span className="absolute top-0 left-0 transform translate-x-1/2 -translate-y-1/2 text-yellow-400">
      *
    </span> */}
  </Link>
</li>

<li className="hover:text-gray-400">
  <Link
  onClick={()=>setNavbarOpen(false)}
    href={`/${lang}/auth/signup`}
    // className="relative px-4 py-2 bg-indigo-500 rounded-lg text-white duration-500 hover:bg-indigo-600"
        className="relative px-4 py-2 rounded-lg text-white bg-teal-500 border-4 border-teal-300 duration-500 hover:bg-teal-600"
  >
    <span className="font-base text-sm">
      {lang === 'fr' ? 'Enregistrement' : 'Sign Up'}
    </span>
    {/* Add a sparkle effect on the border */}
    {/* <span className="absolute top-0 left-0 transform translate-x-1/2 -translate-y-1/2 text-yellow-400">
      *
    </span> */}
  </Link>
</li>

        <label htmlFor="check" className="close-menu mr-4">
        <i className="fa-solid fa-x text-black dark:text-white hover:text-gray-400 duration-200 text-base"/>
        </label>
      </span>

      <label htmlFor="check" className="open-menu dark:text-white">
      <i onClick={()=>setNavbarOpen(!navbarOpen)} className="duration-300 fa-solid fa-bars text-black dark:text-white hover:text-gray-400 text-base"></i>
      </label>

    </ul>

    </div>
  </nav>
</header>
}

export default MainNavbar_3